import { Form, InputNumber, Select, Space, Typography } from "antd";
import { type FormInstance } from "antd/lib/form";

import { ProgramAutomationScheduleAnchor } from "@fitness-app/data-models/entities/ProgramAutomation";

interface ScheduleTimingFieldsProps {
  formController?: FormInstance<any>;
}

const scheduleAnchorOptions = [
  {
    label: "W tygodniu/dniu automatyzacji",
    value: ProgramAutomationScheduleAnchor.WeekDay,
  },
  {
    label: "X dni po rozpoczęciu pakietu",
    value: ProgramAutomationScheduleAnchor.PackageStart,
  },
  {
    label: "X dni przed/po końcu pakietu",
    value: ProgramAutomationScheduleAnchor.PackageEnd,
  },
  {
    label: "W procencie trwania pakietu",
    value: ProgramAutomationScheduleAnchor.PackageProgress,
  },
];

export const ScheduleTimingFields = ({ formController }: ScheduleTimingFieldsProps) => {
  const scheduleTiming = Form.useWatch("scheduleTiming", formController);
  const anchor = scheduleTiming?.anchor ?? ProgramAutomationScheduleAnchor.WeekDay;

  return (
    <>
      <Form.Item name={["scheduleTiming", "anchor"]} label="Termin zadania">
        <Select
          options={scheduleAnchorOptions}
          onChange={(value: ProgramAutomationScheduleAnchor) => {
            // drop offsetDays/percent from the previous anchor so stale values are not submitted
            formController?.setFieldValue("scheduleTiming", { anchor: value });
          }}
        />
      </Form.Item>

      {anchor === ProgramAutomationScheduleAnchor.PackageStart && (
        <Form.Item
          name={["scheduleTiming", "offsetDays"]}
          label="Dni po rozpoczęciu"
          rules={[
            { required: true, message: "Uzupełnij liczbę dni" },
            { type: "number", min: 0, message: "Liczba dni nie może być ujemna" },
          ]}
        >
          <InputNumber min={0} precision={0} />
        </Form.Item>
      )}

      {anchor === ProgramAutomationScheduleAnchor.PackageEnd && (
        <Form.Item label="Przesunięcie względem końca">
          <Space direction="vertical">
            <Form.Item
              name={["scheduleTiming", "offsetDays"]}
              noStyle
              rules={[{ required: true, message: "Uzupełnij liczbę dni" }]}
            >
              <InputNumber precision={0} />
            </Form.Item>
            <Typography.Text type="secondary">Wpisz wartość ujemną dla dni przed końcem, np. -7.</Typography.Text>
          </Space>
        </Form.Item>
      )}

      {anchor === ProgramAutomationScheduleAnchor.PackageProgress && (
        <>
          <Form.Item
            name={["scheduleTiming", "percent"]}
            label="Procent pakietu"
            rules={[
              { required: true, message: "Uzupełnij procent pakietu" },
              { type: "number", min: 0, max: 100, message: "Procent musi być w zakresie 0-100" },
            ]}
          >
            <InputNumber min={0} max={100} precision={0} addonAfter="%" />
          </Form.Item>
          <Form.Item name={["scheduleTiming", "offsetDays"]} label="Dodatkowe dni przesunięcia">
            <InputNumber precision={0} />
          </Form.Item>
        </>
      )}
    </>
  );
};
